
  import {defineComponent} from "vue";
  import PopupComponent from "@/components/shared/PopupComponent.vue";

  export default defineComponent({
    name: 'non-member-view-for-app',
    components: {
      PopupComponent,
    },
    data() {
      return {
        showReconnectionPopup: true,
      }
    },
    computed: {
      showDimmed(): boolean {
        return this.showReconnectionPopup;
      },
    },
    methods: {
      closeWebView(): void {
        const message = JSON.stringify({
          command: 'pop',
        });
        (window as any).ReactNativeWebView.postMessage(message);
      },
    },
  })
